import BaseModelFactory from './base.factory'
import WheelOfLoveWinnerService from './../services/WheelOfLoveWinner.service'
import WheelOfLoveWinner from './../models/wheel-of-love-winner.model'

class WheelOfLoveWinnerFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: WheelOfLoveWinnerService, Model: WheelOfLoveWinner }
    )

  static findAll = async () =>
    await this._findAllBy({}, { Service: WheelOfLoveWinnerService, Model: WheelOfLoveWinner })

  static findByWeek = async (weekStart, weekEnd) =>
    await this._search(
      {
        search: {
          contest_week_start: weekStart,
          contest_week_end: weekEnd,
        },
        pagination: false,
      },
      { Service: WheelOfLoveWinnerService, Model: WheelOfLoveWinner }
    )

  static create = payload =>
    this._create(payload, {
      Service: WheelOfLoveWinnerService,
      Model: WheelOfLoveWinner,
    })
}

export default WheelOfLoveWinnerFactory
